import './Resources.css';

function Resources() {
  return (
    <>
      <p>Product Component</p>
    </>
  );
}

export default Resources;
